
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeShopGrid extends Serenity.EntityGrid<PsDiscCouponTypeShopRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeShopColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeShopDialog; }
        protected getIdProperty() { return PsDiscCouponTypeShopRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeShopRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeShopRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeShopService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}